export const trackProductReview = ({
  action,
  productId,
}: {
  action: 'impression' | 'click' | 'submit';
  productId: string;
}) => {
  const event = {
    event: 'product_review',
    action: action,
    label: productId,
    value: null,
  };

  return event;
};
